import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import * as React from 'react';
import Stepper from '@material-ui/core/Stepper/Stepper';
import Step from '@material-ui/core/Step/Step';
import StepLabel from '@material-ui/core/StepLabel/StepLabel';
import GoToPortal from './GoToPortal/GoToPortal';
import PersonalDetailsForm from './PersonalDetailsForm/PersonalDetailsForm';
import { AscendState } from '../../ducks';
import { connect, Dispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography/Typography';
import Grid from '@material-ui/core/Grid/Grid';
import { OnboardDetails } from '../../models/onboardDetails';
import { SAVE_OR_SUBMIT, SUBMIT_DETAILS } from '../../ducks/actions';
import * as styles from './Onboard.css';
import ConfirmEligibility from './ConfirmEligibility/ConfirmEligibility';
import ClientAgreement from './ClientAgreement/ClientAgreement';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import {
  getInitialContractData,
  getInitialContractLoading,
} from '../../ducks/onboard/onboardSelectors';

const steps = ['Personal Details', 'Confirm Eligibility', 'Client Services Agreement'];

type StateProps = {
  currentStep: number;
  agreementPage: number;
  initialAgreementValues: any;
  agreementLoading: boolean;
  submittingAgreement: boolean;
  isMobile?: boolean;
};

type DispatchProps = {
  saveOrSubmit: (currentPage: number, submitted?: boolean) => void;
  addDetails: (details: OnboardDetails) => void;
};

type OnboardProps = StateProps & DispatchProps;

const Icon = (index: number, currentStep: number) => (
  <svg style={{ fill: 'rgb(79, 179, 191)' }} width="40" height="40">
    <circle cx="18" cy="18" r="18" />
    <text style={{ fontSize: '1.35rem', fill: 'white', textAnchor: 'middle' }} x="18" y="24">
      {currentStep > index ? '✓' : index + 1}
    </text>
  </svg>
);
const Onboard = (props: OnboardProps) => (
  <Layout>
    <Stepper
      className={styles.stepper}
      activeStep={props.currentStep >= 3 ? 3 : props.currentStep}
      alternativeLabel>
      {steps.map((label, i) => (
        <Step key={label}>
          <StepLabel icon={Icon(i, props.currentStep)} classes={{ iconContainer: styles.icon }}>
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
    {getStepContent(props)}
  </Layout>
);

const getStepContent = ({
  isMobile,
  currentStep,
  agreementPage,
  initialAgreementValues,
  agreementLoading,
  submittingAgreement,
  saveOrSubmit,
  addDetails,
}: OnboardProps) => {
  switch (currentStep) {
    case 0: {
      return (
        <>
          <Title text="Let's Get Started!" center />
          <Grid container justify="center">
            <Grid item xs={11} sm={8} md={6} container direction="column">
              <Typography align="center" variant="headline">
                Please Provide a Few Details
              </Typography>
              <PersonalDetailsForm onSubmit={(details: OnboardDetails) => addDetails(details)} />
            </Grid>
          </Grid>
        </>
      );
    }
    case 1: {
      return <ConfirmEligibility />;
    }
    case 2: {
      return (
        <>
          {agreementLoading ? (
            <Grid container justify="center">
              <CircularProgress className={styles.loading} size={100} />
            </Grid>
          ) : (
            <ClientAgreement
              isMobile={isMobile}
              initialAgreementPage={agreementPage}
              initialAgreementValues={initialAgreementValues}
              saveOrSubmit={saveOrSubmit}
              submittingAgreement={submittingAgreement}
            />
          )}
        </>
      );
    }
    case 3: {
      return <GoToPortal />;
    }
    default: {
      return 'Unknown stepIndex';
    }
  }
};

const mapStateToProps = (state: AscendState) => ({
  isMobile: state.layout.isMobile,
  currentStep: state.onboard.currentStep,
  agreementPage: state.onboard.agreementPage,
  initialAgreementValues: getInitialContractData(state),
  agreementLoading: getInitialContractLoading(state),
  submittingAgreement: state.onboard.clientAgreement.loading,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  addDetails: (details: OnboardDetails) => dispatch({ type: SUBMIT_DETAILS, details }),
  saveOrSubmit: (currentPage: number, submitted?: boolean) =>
    dispatch({ type: SAVE_OR_SUBMIT, currentPage, submitted }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Onboard);
